import { css } from '@emotion/core'
import { colors, measures } from 'styles/variables'
import * as MEDIA from 'styles/media-queries'

const { unit } = measures

export const resetSection = css`
  display: flex;
  flex-direction: column;
  align-items: center;

  min-width: ${50 * unit}px;

  border-radius: ${unit}px;

  padding: ${3 * unit}px;

  ${MEDIA.PHONES} {
    width: 100%;
  }
`

export const mobileView = css`
  display: none;
  background-color: ${colors.grays.gray6};
  margin: 0;
  padding: 0;
  
  ${MEDIA.TABLETS} {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
    overflow: hidden;
  }
`

export const desktopView = css`
  display: block;
  
  ${MEDIA.TABLETS} {
    display: none;
  }
`
